import axios from "axios";
import { PayloadRegister } from "../entities/PayloadRegister";
import { ResponseSuccess } from "../entities/ResponseSuccess";

// API Endpoint
const API_URL = `${process.env.REACT_APP_API_URL}customer-leads`;
const API_SUPARK_URL = `${process.env.REACT_APP_API_URL}sudirman-customer`

export const sendRegister = async (payload: PayloadRegister): Promise<ResponseSuccess> => {
  try {
    const response = await axios.post(API_URL, payload, {
      headers: {
        "Content-Type": "application/json", // Specify JSON format
      },
    });

    // Map the response to an instance of ResponseSuccess
    const { status, message } = response.data;
    return new ResponseSuccess(status, message);
  } catch (error) {
    // Handle error
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.message || "An error occurred.");
    } else {
      console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred.");
    }
  }
};

export const sendRegisterSudirman = async (payload: FormData): Promise<ResponseSuccess> => {
  try {
    const response = await axios.post(API_SUPARK_URL, payload, {
      headers: {
        "Content-Type": "multipart/form-data", // Specify JSON format
      },
    });

    // Map the response to an instance of ResponseSuccess
    const { status, message } = response.data;
    return new ResponseSuccess(status, message);
  } catch (error) {
    // Handle error
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.message || "An error occurred.");
    } else {
      console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred.");
    }
  }
};